function show_time(day){
    var time_start = new Date().getTime(); //设定当前时间
    // 计算时间差
    var time_distance = day - time_start;//604800000
    // 天
    var int_day = Math.floor(time_distance/86400000)
    time_distance -= int_day * 86400000;
    // 时
    var int_hour = Math.floor(time_distance/3600000)
    time_distance -= int_hour * 3600000;
    // 分
    var int_minute = Math.floor(time_distance/60000)
    time_distance -= int_minute * 60000;
    // 秒
    var int_second = Math.floor(time_distance/1000)
    // 时分秒为单数时、前面加零
    if(int_day < 10){
        int_day = "0" + int_day;
    }
    if(int_hour < 10){
        int_hour = "0" + int_hour;
    }
    if(int_minute < 10){
        int_minute = "0" + int_minute;
    }
    if(int_second < 10){
        int_second = "0" + int_second;
    }
    // 显示时间
    $(".countdown_day").html(int_day);
    $(".countdown_hours").html(int_hour);
    $(".countdown_minute").html(int_minute);
    $(".countdown_second").html(int_second);
    return {int_hour:int_hour,day:day};
};
if(!window.localStorage.getItem('day')){
    window.localStorage.setItem('day',new Date().getTime()+604800000);
    clearInterval(time);
    var time=setInterval(function(){
        show_time(window.localStorage.getItem('day'));
    },1);
}else{
    clearInterval(time);
    var time=setInterval(function(){
        show_time(window.localStorage.getItem('day'));
    },1);
};
setTimeout(function(){
    for(var i=0;i<$('.time_limit>div i').length;i++){
        if($('.time_limit>div i').eq(i).html().indexOf('-')!=-1||Number($('.time_limit>div i').eq(i).html())>7){
            window.localStorage.setItem('day',new Date().getTime()+604800000);
        }else{
            break;
        }
    }
},20);